export const KENO_NUMBERS_COUNT = 80;

export const kenoNumbers = new Array(KENO_NUMBERS_COUNT).fill(null).map((el, index) => index + 1);

export const randomTicketsGeneratorCount = [50, 25, 20, 15, 10, 5];
export const randomTicketNumbersGeneratorCount = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
export const randomTicketNumbersGeneratorCountKeno8 = [8, 7, 6, 5, 4, 3, 2, 1];

export const TicketsCount = [5, 20, 50];

export const DEMO_GAME_CURRENCY = 'FUN';

export const SELECTED_NUMBERS_MAX_COUNT_KENO10 = 10;
export const SELECTED_NUMBERS_MAX_COUNT_KENO8 = 8;

export const KENO_NUMBERS_ANIMATION_DURATION_IS_TURBO = 3000;
export const KENO_NUMBERS_ANIMATION_DURATION = 500;
export const KENO_NUMBERS_ANIMATION_END = 1000;

export const WIN_ODD_FOR_POPUP = 10;

export const MAX_TICKETS_COUNT = 400;

export const TAB_INDEX = {
  BetSlip: 0,
  AllBets: 1,
};

export const TAB_INDEX_FOR_FAIRNESS = {
  History: 0,
  Fairness: 1,
};
